(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionnaireTemplateComponent', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addQuestion = '&?';
        directiveScope.addStaticText = '&?';
        directiveScope.toDeleteStaticText = '&?';
        directiveScope.addPageBreak = '&?';

        directiveScope.editComponentList = '&?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                 
                    /**
                     * @property {{
                     *      ODDQuestionType: {
                     *          CategoryCode,
                     *          CategoryBehaviour
                     *      }
                     * }} $scope.boxModel
                     */

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/oddQuestionnaireTemplateComponent.[Template].tpl.html';

                    $controller('BoxTmplController', {$scope: $scope});

                    $scope.goToQuestion = function (question) {
                        $scope.clickOnBox({ question: question });
                    };
                }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();